import { useQuery } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

export const useMaintenanceMode = () => {
  const currentWorkspaceId = useCurrentWorkspaceId()

  return useQuery(
    'maintenance_mode',
    async () => {
      const res = await sendToApi<{
        features: {
          maintenance_mode: {
            enabled: boolean
          }
        }
        flipper_id: string
      }>(`/flipper/actors/Company;${currentWorkspaceId}?keys=maintenance_mode`)
      return res.type === SUCCESS_RESPONSE_TYPE && res.data.features.maintenance_mode.enabled
    },
    {
      cacheTime: 0,
      refetchOnWindowFocus: true,
      retry: false,
    },
  )
}
